import { createClient, type SupabaseClient, type SupportedStorage } from '@supabase/supabase-js';
import type { Database } from './database.types';

export * from './database.types';
export type AslenClient = SupabaseClient<Database>;

export interface AslenClientOptions {
  storage?: SupportedStorage;
  detectSessionInUrl?: boolean;
  persistSession?: boolean;
  storageKey?: string;
}

export function createAslenClient(url: string, anonKey: string, opts: AslenClientOptions = {}): AslenClient {
  return createClient<Database>(url, anonKey, {
    auth: {
      storage: opts.storage,
      storageKey: opts.storageKey ?? 'aslen-ops-auth',
      persistSession: opts.persistSession ?? true,
      autoRefreshToken: true,
      detectSessionInUrl: opts.detectSessionInUrl ?? false,
      flowType: 'pkce',
    },
    realtime: { params: { eventsPerSecond: 5 } },
    global: { headers: { 'x-client-info': 'aslen-ops' } },
  });
}
